import React from 'react';
import { motion } from 'framer-motion';
export function PainSection() {
  return <section className="py-20 px-6 max-w-2xl mx-auto border-t border-white/5" data-id="element-127">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.8
    }} data-id="element-128">
        <h2 className="font-serif text-3xl md:text-4xl text-gold-400 mb-12 text-center" data-id="element-129">
          The moment this is for
        </h2>

        <div className="space-y-8 text-lg md:text-xl leading-loose-p text-cream-50" data-id="element-130">
          <p data-id="element-131">If you've ever stared at the ceiling at 3:18am thinking:</p>

          <p className="font-serif text-2xl italic text-cream-100/90 text-center py-4" data-id="element-132">
            "I can't do another night like this."
          </p>

          <p data-id="element-133">But then you do.</p>
          <p data-id="element-134">Because you have to.</p>
          <p data-id="element-135">And the worst part isn't even the waking.</p>
          <p data-id="element-136">It's the feeling that comes with it:</p>

          <ul className="space-y-4 pl-4 my-8" data-id="element-137">
            {["You're the default parent.", "You're also the default planner.", "You're also the one who has to 'ask nicely.'", "And you're also the one who gets blamed for 'being emotional.'"].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-138">
                <span className="text-gold-400 mt-2 text-xs" data-id="element-139">●</span>
                <span data-id="element-140">{item}</span>
              </li>)}
          </ul>

          <p data-id="element-141">Sleep deprivation doesn't just make you tired.</p>
          <p className="text-gold-400 font-medium" data-id="element-142">
            It makes you someone you don't recognize.
          </p>
        </div>
      </motion.div>
    </section>;
}